import { Route, Routes } from 'react-router-dom'
import { FC } from 'react'
import List from './action-plan/List'
import RealEstateNews from './real-estate-news/RealEstateNewsList'
import MarketUpdatesList from './market-updates/MarketUpdatesList'
import SmartListingAlert from './smart-listing-alert'
import LeadEngagementAlert from './lead-engagement-alert'

export const AutomationRoutes: FC = () => {
 return (
  <Routes>
   <Route path="action-plan" element={<List />} />
   <Route path="market-updates" element={<MarketUpdatesList />} />
   <Route path="real-estate-news" element={<RealEstateNews />} />
   <Route path="ai-listing-intelligence" element={<SmartListingAlert />} />
   <Route
    path="ai-lead-engagement-intelligence"
    element={<LeadEngagementAlert />}
   />
  </Routes>
 )
}
